<template>
  <div class="account-wrap">
    <div class="seletc-list">
      <el-select
        v-model="filterData.advertiserIds"
        multiple
        filterable
        class="multiple-select"
        collapse-tags
        placeholder="选择广告账户"
        @change="clickSearch()"
        clearable
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.advertiserName + ' (' + item.advertiserId + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 10px"
        v-model="filterData.projectIds"
        multiple
        filterable
        class="multiple-select"
        :filter-method="filterAdSeries"
        collapse-tags
        placeholder="选择广告系列"
        @change="clickSearch()"
        clearable
      >
        <el-option
          v-for="item of adSeriesList"
          :key="item.campaignId"
          :label="item.campaignName"
          :value="item.campaignId"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 10px"
        class="multiple-select"
        filterable
        clearable
        v-model="filterData.promotionIds"
        :filter-method="filterPromotion"
        placeholder="选择广告组"
        @change="clickSearch()"
        multiple
        collapse-tags
      >
        <el-option v-for="item of promotionList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 10px"
        v-model="filterData.assetTypes"
        collapse-tags
        multiple
        clearable
        placeholder="选择素材类型"
        @change="clickSearch()"
      >
        <el-option
          v-for="item of assetTypesList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 10px"
        v-model="filterData.reviewStatusList"
        collapse-tags
        multiple
        clearable
        placeholder="选择素材审核"
        @change="clickSearch()"
      >
        <el-option
          v-for="item of reviewStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 10px"
        v-model="filterData.performances"
        collapse-tags
        multiple
        clearable
        placeholder="选择素材表现"
        @change="clickSearch()"
      >
        <el-option
          v-for="item of performancesList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 10px"
        multiple
        collapse-tags
        v-if="isAdmin"
        v-model="filterData.userIds"
        clearable
        placeholder="选择优化师"
        @change="clickSearch()"
      >
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 10px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch()"
      >
      </el-date-picker>
      <!-- <el-button class="submit-btn" type="primary" @click="clickSearch()"
        >提交</el-button
      > -->
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-input
          placeholder="请输入素材资源名称"
          prefix-icon="el-icon-search"
          v-model="filterData.search"
          class="search-input"
          style="width: 190px"
          @change="inputSearch"
        >
        </el-input>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :platType="5"
          :type="4"
          style="margin-left: auto"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-download"
          style="margin-left: 16px"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table :data="tableList" :max-height="tableMaxHeight" v-loading="loading">
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              width="200"
              :key="item.value"
            >
              <template slot-scope="scope">
                <span>{{ scope.row[item.value] || "--" }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              :width="item.width"
              :key="item.value"
            >
              <template slot-scope="scope">
                <el-popover
                  popper-class="group-popver"
                  v-if="item.value === 'adGroupAssetList'"
                  placement="top-start"
                  title=""
                  width="400"
                  trigger="hover"
                >
                  <div
                    class="popver-item"
                    v-for="child in scope.row.adGroupAssetList"
                    :key="child.adGroupId"
                  >
                    <div class="name-link" @click="checkAdGroup(child)">
                      {{ child.adGroupName }}
                    </div>
                    <div class="name-item">
                      素材表现：<span>{{ child.performanceLabel }}</span>
                    </div>
                    <div class="name-item" style="width: 30%">
                      审核状态：<span>{{
                        (reviewStatusOptions.find((v) => v.value == child.reviewStatus) || {}).label
                      }}</span>
                    </div>
                  </div>
                  <span slot="reference" style="cursor: pointer"
                    >{{ scope.row.adGroupAssetList.length }} 个广告组</span
                  >
                </el-popover>
                <span v-else-if="item.value === 'assetType'">{{
                  assetTypesList.find((child) => child.value === scope.row.assetType).label
                }}</span>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectField from "@/components/selectField.vue";
import {
  getAdCampaignList,
  getGoogleAdMaterialReport,
  getAdCommonAdGroupList,
} from "@/api/promotion-google.js";
import {
  attribute,
  baseData,
  appData,
  assetTypesList,
  reviewStatusOptions,
  performancesList,
} from "@/config/fieldData_google";
import { getAdCountList } from "@/api/promotion-gdt.js";
import { getUserInfoList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import { formatTableList } from "../formatData.js";
import moment from "moment";
export default {
  name: "AccountTable",
  components: {
    SelectField,
  },
  data() {
    return {
      loading: false,
      assetTypesList,
      reviewStatusOptions,
      performancesList,
      advertiserIdList: [],
      adSeriesList: [],
      copyAdSeriesList: [],
      promotionList: [],
      copyPromotionList: [],
      optimizerList: [],
      mccList: [],
      filterData: {
        advertiserIds: [],
        projectIds: [],
        promotionIds: [],
        assetTypes: [],
        reviewStatusList: [],
        performances: [],
        userIds: [],
        time: [
          moment().subtract(7, "days").format("YYYY-MM-DD"),
          moment().subtract(1, "days").format("YYYY-MM-DD"),
        ],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.materialResources },
        { title: "基础数据", list: baseData },
        { title: "APP数据", list: appData.materialResources },
      ],
      staticOptions: [
        { label: "素材ID", value: "assetId", width: "200" },
        { label: "素材名称", value: "assetName", width: "200" },
      ],
      tableList: [],
      tableCols: [],
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
      timer: null,
      totalColumn: {},
      totalReportInfo: [],
    };
  },
  mounted() {
    this.initSelectOptions();
    this.clickSearch();
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.login.isAdmin,
    }),
  },
  watch: {
    totalReportInfo: {
      handler(value) {
        let totalData = {};
        if (value?.length > 0) {
          totalData = value[0];
        }
        totalData.assetId = "合计";
        totalData.assetName = `总共${this.pageData.total || 0}条数据`;
        totalData.status = "--";
        this.totalColumn = totalData;
      },
      immediate: true,
    },
  },
  methods: {
    initSelectOptions() {
      getAdCountList({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      getAdCampaignList({
        pageSize: 9999,
        page: 1,
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.adSeriesList = res.data.list;
          this.copyAdSeriesList = res.data.list;
        }
      });
      getAdCommonAdGroupList({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.promotionList = res.data;
          this.copyPromotionList = res.data;
        }
      });
      getUserInfoList({
        orgIds: 254,
      }).then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.data;
        }
      });
    },
    filterPromotion(value) {
      this.promotionList = this.copyPromotionList.filter((item) => {
        let valueStr = String(value);
        return (
          item.id.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.name.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
    filterAdSeries(value) {
      this.adSeriesList = this.copyAdSeriesList.filter((item) => {
        let valueStr = String(value);
        return (
          item.campaignId.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.campaignName.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startDate: this.filterData.time[0],
        endDate: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        parmas[key] = checkData;
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        //预算
        item.budget = item.budgetMode === "BUDGET_MODE_DAY" ? item.budget : "不限";
        //状态
        item.status = item.status === "1" ? "可用" : "异常";
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        //条件查询
        this.filterData.pkgs = [];
        this.filterData.userIds = [];
        this.filterData.status = "";
        this.filterData.advertiserIds = [filterData.advertiserId];
        this.filterData.projectIds = [filterData.campaignId];
        this.filterData.promotionIds = [filterData.adGroupId];
        this.filterData.time = filterData.time;
        this.filterData.search = "";
      }
      let parmas = this.formatData();
      this.loading = true;
      getGoogleAdMaterialReport(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.pageInfo?.list || []);
          if (this.pageData.page === 1) {
            const data = JSON.parse(
              JSON.stringify(res.data.totalReportInfo ? [res.data.totalReportInfo] : [])
            );
            this.totalReportInfo = this.formatTableData(data);
          }
          this.pageData.total = res.data.pageInfo?.total || 0;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "adGroupAssetList",
          "cost",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "convertCnt",
          "convertCntCost",
          "convertCntRate",
        ];
      }
      let allFieldsMap = attribute.materialResources.concat(baseData, appData.materialResources); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      getGoogleAdMaterialReport(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.pageInfo?.list || []);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "投放账号.xlsx", HeaderData);
        }
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    checkAdGroup(data) {
      this.$emit("checkTable", {
        name: "AdvertiseTable",
        data: {
          adGroupId: data.adGroupId,
          time: this.filterData.time,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.account-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      width: 260px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .status {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 4px;
        }
        &.start::before {
          background: rgba(30, 194, 57, 1);
        }
        &.stop::before {
          background: rgba(235, 49, 49, 1);
        }
      }
    }
  }
  .piliang {
    height: 45px;
    line-height: 45px;
    padding-left: 12px;
    margin-left: 12px;
    display: flex;
    justify-content: space-between;
    .batch-span {
      font-size: 13px;
      color: rgba(0, 0, 0, 1);
      a {
        color: rgba(24, 144, 255, 1);
        margin: 0 5px;
      }
    }
    .icon-list {
      margin-left: 58px;
      color: rgba(24, 144, 255, 1);
    }
    .batch-icon {
      margin-right: 26px;
      cursor: pointer;
    }
    .close-btn {
      color: rgba(0, 0, 0, 0.6);
      font-size: 12px;
      margin: 0 16px 0 40px;
      cursor: pointer;
    }
  }
}
.group-popver {
  width: 100%;
  .popver-item {
    display: flex;
    font-size: 10px;
    width: 100%;
    margin-bottom: 8px;
    .name-link {
      width: 30%;
      color: #1890ff;
      cursor: pointer;
      user-select: none;
      &:hover {
        color: #0285ff;
      }
    }
    .name-item {
      width: 40%;
    }
  }
}
</style>
